import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import ContentGrid from './../ContentGrid'

const TeamGrid = (props) => {
    
    const data = useStaticQuery(graphql`
        query {
            ourTeam: allStoryblokEntry(filter: {
                full_slug: {
                    regex: "/team\\/our-team/"
                }
            }) {
                nodes {
                    id
                    slug
                    field_component
                    content
                    name
                }
            },
            boardOfDirectors: allStoryblokEntry(filter: {
                full_slug: {
                    regex: "/team\\/board-of-directors/"
                }
            }) {
                nodes {
                    id
                    slug
                    field_component
                    content
                    name
                }
            },
            boardOfAdvisors: allStoryblokEntry(filter: {
                full_slug: {
                    regex: "/team\\/board-of-advisors/"
                }
            }) {
                nodes {
                    id
                    slug
                    field_component
                    content
                    name
                }
            }
        }
    `)

    return (
        <ContentGrid blok={props.blok} data={data} type='team' />
    )
}

export default TeamGrid
